import React, {useState, useEffect} from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {Tabs, Tab} from "react-bootstrap";
//import moment from "moment";
import "./../../../Public/css/tabler-icons.css";
import "./../../../Public/css/fontawesome.min.css";
import "./../../../Public/css/all.min.css";
import "./../../../Public/css/style.css";

import {getProfileInfoAPI, getStagePipelineAPI} from "./../../../API/Sales/LeadAPI";
/*import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";*/
//import { ProfileContext } from "./ProfileContext";
import BasicProfile from "./Profile/BasicProfile";
import OtherProfile from "./Profile/OtherProfile";
import Notification from "./Profile/Notification";
import Remarks from "./Profile/Remarks";
import SendMail from "./Profile/SendMail";
import Layout from "./../Layout";
import { ToastContainer } from "react-toastify";


const LeadProfile = () =>{

    const {leadid} = useParams();
    //const current = moment();
	const navigate = useNavigate();

	//const [btnloading, setBtnLoading] = useState(false);
	const [activetabs, setActiveTabs] = useState("activities");
	const [pipeline, setPipeline] = useState([]);
	const [txtpipeline, setTxtPipeline] = useState("");
	//const [profiledata, setProfileData] = useState({basicinfo: null, otherinfo: null, remarks: [], notifications: []});
	const [basicinfo, setBasicInfo] = useState(null);
	const [otherinfo, setOtherInfo] = useState(null);
	const [notifications, setNotifications] = useState([]);
	const [remarks, setRemarks] = useState([]);
	const [pageloader, setPageLoader] = useState(true);
	const [ispipelinereload, setIsPipelineReload] = useState(false);
	const [reload, setReload] = useState(false);
	const [btnrefreshloader, setBtnRefreshLoader] = useState(false);
	const [recordingurl, setRecordingURL] = useState("");
	

	useEffect(()=>{

		console.log('Reloas pipeline api');
		getStagePipelineAPI(setPipeline, setTxtPipeline, setIsPipelineReload, leadid);

	}, [ispipelinereload, leadid]);

    useEffect(()=>{

        //getProfileInfoAPI(setName, setEmail, setContact, setLocation, setStage, setDisposition, setSubDisposition, setOtherEmail, setOtherContact, setProgram, setInstitute, setSource, setCreatedDate, setLastUpdated, setRemarks, setPipeline, setNotifications, setTxtPipeline, leadid);

		//getProfileInfoAPI(setProfileData, setPipeline, setTxtPipeline, leadid);
		getProfileInfoAPI(setBasicInfo, setOtherInfo, setRemarks, setPipeline, setTxtPipeline, leadid, setPageLoader, setBtnRefreshLoader, setRecordingURL);

		console.log('pipeline lngth=====' + pipeline.length );

		//console.log('under basic profile=====' + JSON.stringify(profiledata));

    }, [leadid, reload]);

	/*const reloadPipeline = React.useCallback(() => {
    	getStagePipelineAPI(setPipeline, setTxtPipeline, leadid);
	}, [leadid]);

	const providerValue = {
        profileid: leadid,
        profiledata,
        setProfileData,

        pipeline,
        txtpipeline,

        reloadPipeline,
    };*/

	const handleReloadPageData = () =>{

		setBtnRefreshLoader(true);
		
		setReload(prev => !prev);
	}

	const sendBackPage = () =>{
		navigate(-1)
	}


	//console.log("PROFILE DATA >>>", profiledata);

	if(pageloader) return <div>Profile Loading...</div>;

    return(
	<Layout>
		<div className="content">

			<div className="row">
				<div className="col-md-12">

					<div className="page-header">
						<div className="row align-items-center">
							<div className="col-sm-4">
								<h4 className="page-title">Leads Overview </h4>
							</div>
							<div className="col-sm-8 text-sm-end">
								<div className="head-icons">
									
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div className="row">
				<div className="col-md-12">

					<div className="contact-head">
						<div className="row align-items-center">
							<div className="col-sm-6">
								<ul className="contact-breadcrumb">
									<li>
                                        <button type="button" className="btn btn-dark" onClick={sendBackPage}>
                                            <i className="ti ti-arrow-narrow-left"></i>Back
                                        </button>
                                    </li>
                                    <li>
										<button type="button" class="btn btn-primary crm-refresh-btn" onClick={handleReloadPageData}>
											<i className={`ti ti-refresh me-1 ${btnrefreshloader ? 'spin' : ''}`}></i>Refresh Data
										</button>
									</li>
								</ul>
							</div>
							<div className="col-sm-6 text-sm-end">
								<ul className="contact-breadcrumb">
									{recordingurl &&
									<li>
                                        <audio controls preload="none">
    										<source src={recordingurl} type="audio/wav" />
    										Your browser does not support the audio element.
										</audio>
                                    </li>
									}
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-6 d-flex">
					<div className="card crm-lead-summary-card h-100 w-100">
						<div className="card-body">

							<BasicProfile profiledata={basicinfo} profileid={leadid} onReload={handleReloadPageData}  />

						</div>
					</div>
				</div>

				<div className="col-xl-6 d-flex">
					<div className="card crm-top-pipeline-card h-100 w-100">
						<div className="card-body">
							{pipeline.length <= 0 ?
								(txtpipeline !== "" && txtpipeline !== null ?
									<>
									{/*<h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>*/}
									<div className="pipeline-list crm-top-pipeline-scroll">
										<ul>
											<li>
												<Link to="#" className={txtpipeline.name === 'Warm' ? "bg-pending" :
																		(txtpipeline.name === 'Contacted' ? "bg-contacted" :
																		(txtpipeline.name === 'Dead' ? "bg-dead" :
																		(txtpipeline.name === 'Cold' ? "bg-cold" :
																		(txtpipeline.name === 'Attempt to Contact' ? "bg-attempt" :
																		(txtpipeline.name === 'Enrolled' ? "bg-enrolled" :
																		(txtpipeline.name === 'Duplicate' ? "bg-duplicate" :
																		(txtpipeline.name === 'Dropout' ? "bg-dropout" : "" )
																		)
																	)
																)
															)
														)
													)
												}>{txtpipeline?.name}</Link>
											</li>
										</ul>
									</div>

									</>
								:
									<></>
								)
							:
								<>
								{/*<h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>*/}
								<div className="pipeline-list crm-top-pipeline-scroll">
									<ul>
										{
											pipeline.map((pipeliedata, index)=>
											(
												<li key={index}>

													<Link to="#" className={pipeliedata.name === 'Warm' ? "bg-pending" :
																			(pipeliedata.name === 'Contacted' ? "bg-contacted" :
																			(pipeliedata.name === 'Dead' ? "bg-dead" :
																			(pipeliedata.name === 'Cold' ? "bg-cold" :
																			(pipeliedata.name === 'Attempt to Contact' ? "bg-attempt" :
																			(pipeliedata.name === 'Enrolled' ? "bg-enrolled" :
																			(pipeliedata.name === 'Duplicate' ? "bg-duplicate" :
																			(pipeliedata.name === 'Dropout' ? "bg-dropout" : "" )
																			)
																		)
																	)
																)
															)
														)
													}>{pipeliedata.name}</Link>
												</li>
											))
										}

									</ul>
								</div>

								</>
							}
							
						</div>
					</div>
				</div>

				<div className="col-xl-6 d-flex">
					<div className="card crm-info-card h-100 w-100">
						<OtherProfile profiledata={otherinfo} profileid={leadid} onReload={handleReloadPageData} />
					</div>
				</div>

				<div class="col-md-6 d-flex">
					<Remarks profiledata={remarks} pipelineReloadStatus={() => setIsPipelineReload(prev => !prev)} profileid={leadid} onReload={handleReloadPageData}  />
				</div>
			</div>
		</div>
			
		<ToastContainer />
    </Layout>
    )
}

export default LeadProfile;